import { STORES, getOfflineDb } from "./idbDatabase";

/** Read a cached entity list or object by stable string key. */
export async function readCache(key) {
  const db = await getOfflineDb();
  const row = await db.get(STORES.cache, key);
  return row?.value ?? null;
}

/** Write cache entry with updated timestamp. */
export async function writeCache(key, value) {
  const db = await getOfflineDb();
  await db.put(STORES.cache, {
    key,
    value,
    updatedAt: new Date().toISOString(),
  });
}

export async function removeCache(key) {
  const db = await getOfflineDb();
  await db.delete(STORES.cache, key);
}
